module.exports = __webpack_public_path__ + "media/application/images/img/overlays/04-0284d042a6c29213aaa1979528195b7f.png";